import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import { Nav, Tab, Row, Col, Container, Form } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-datetime/css/react-datetime.css";
import Accordion from "react-bootstrap/Accordion";
import { useParams, useHistory } from "react-router-dom";
import useAxiosFile from "../../actions/useaxios";
import config from "../../actions/config";
import {
  DecryptData,
  EncryptData,
  MinuteHourFormat,
  isEmpty,
} from "../../actions/common";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { GetAddressBasedOnLatLng, GetLatLngBasedOnAddress } from "../Map/geocode";

import deletSvg from "../../assests/svg/delete.svg";

import Autocomplete from "react-google-autocomplete";
import GMap from "../../layouts/Map/GMap";

function AdminView() {
  const initdata = {
    FirstName: "",
    LastName: "",
    EmailId: "",
    Mobile: "",
    DateofBirth: "",
    Gender: "",
    Profile: "",
    role: 'admin',
  };

  const { token, payload } = useSelector((state) => state.admin_panel.User);
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const location = useLocation();
  const { pathname, search, state } = useLocation();
  console.log("dfgd", token);
  console.log('locationlocation', location)

  const navigate = useNavigate();
  let id = DecryptData(location?.search.split("?Id=")[1]);

  const axiosFile = useAxiosFile();


  const [activeTab, setActiveTab] = useState("profile");
  const [formValue, setFormValue] = useState(initdata);
  const [Datas, SetDatas] = useState({ profile: {}, shop: {} });
  const [SelectedShop, SetSelectedShop] = useState({});
  const [Error, SetError] = useState({});
  const [newshopdata, SetNewShopData] = useState({});

  const ActivateOptions = [
    {
      label: "Activate",
      value: false,
    },
    {
      label: "De-Activate",
      value: true,
    }
  ]

  const [Id, Setid] = useState();
  const [passwordText, setPasswordText] = useState("password");

  // const { Id } = useParams()
  const [vendor, setvendor] = useState();
  const [disabledstatus, SetDisabledstatus] = useState({});

  console.log("sdfasdf", vendor);

  useEffect(() => {
    if (location?.state?.data) {
      setFormValue(location?.state?.data)
    }
  }, [location?.state]);

  const [onchangeimg, setOnchangeimg] = useState("");
  const [imageVal, setImageVal] = useState("");
  console.log("hdhsssg", imageVal, location?.pathname);

  useEffect(() => {
    console.log("kjsfsjfs", location.search.split("?Id="));
    if (location?.search) {
      let paramdata = location.search.split("?Id=")[1];
      Setid(
        isEmpty(DecryptData(paramdata)) ? paramdata : DecryptData(paramdata)
      );
    }
  }, [location.search]);


  const gender = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Others", label: "Others" },
  ];

  const driveroptions = [
    { value: "idle", label: "Idle" },
    { value: "intransit", label: "In Transit" },
    { value: "offline", label: "Offline" },
    { value: "active", label: "Active" },
  ];

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid lightgray",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const stylegreendrop = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid #00B167",
      borderRadius: 10,
      fontSize: "13px",
      color: "#00B167",
      fontWeight: 700,
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#00B167",
      fontWeight: 700,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#00B167",
      fontWeight: 700,
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
  });

  const OnChange = (e, type) => {
    console.log("skfskfsgsg", e);
    if (e?.target) {
      const { value, id, files } = e.target;
      if (!isEmpty(Error?.[id])) {
        SetError({ ...Error, ...{ [id]: "" } });
      } else if (files) {
      }
      setFormValue({ ...formValue, ...{ [id]: value } });
    } else if (e?.value) {
      if (!isEmpty(Error?.[type])) {
        SetError({ ...Error, ...{ [type]: "" } });
      }
      setFormValue({ ...formValue, ...{ [type]: e.value } });
    } else if (e) {
      setFormValue({ ...formValue, ...{ [type]: e } });
    }
  };


  console.log("newshopdatanewshopdata", newshopdata);

  const FileChange = (e) => {
    const { id, files } = e.target;
    if (files[0].type.includes("image")) {
      setFormValue({ ...formValue, ...{ [id]: files[0] } });
    } else {
      toast.error("Upload Images Only", 1000);
    }
  };

  const Validate = async () => {
    let error = {};
    if (isEmpty(formValue?.username)) {
      error.username = "Enter User Name";
    }
    if (isEmpty(formValue?.EmailId)) {
      error.EmailId = "Enter Email-Id";
    } else if (!config.EMAIL.test(formValue?.EmailId)) {
      error.EmailId = "Enter Valid Email-Id";
    }
    if (isEmpty(formValue?.Mobile)) {
      error.Mobile = "Enter Mobile";
    } else if (!isValidPhoneNumber(formValue?.Mobile)) {
      error.Mobile = "Enter Valid Mobile";
    }
    if (isEmpty(formValue?.Password) && location?.pathname == "/addadmin") {
      error.Password = "Enter Password";
    }
    else if (!isEmpty(formValue?.Password)) {
      if (!config.PASSWORD.test(formValue?.Password)) {
        error.Password = "Password must contain Alphanumeric and between 8-15 characters";
      }
    }
    return error;
  };

  const Submit = async () => {
    SetDisabledstatus({ Submit: true });
    const toastid = toast.loading("Validating");
    let errorcheck = await Validate();
    console.log("dkjsjkjsfsinnnn", errorcheck);
    if (isEmpty(errorcheck)) {
      let senddata = formValue;
      if (location?.pathname == "/addadmin") {
        senddata.Type = 'add';
      }
      else {
        senddata.Type = 'Edit';
      }
      let Resp = await axiosFile?.AdminAction(senddata);
      console.log("skjdhsfsfs", Resp, senddata);
      if (Resp?.success == "success") {
        toast.update(toastid, {
          type: "success",
          render: Resp?.msg,
          isLoading: false,
          autoClose: 1000,
        });
        // toast.success(Resp?.msg, 1000);
        navigate("/adminlist");
      } else {
        toast.update(toastid, {
          type: "error",
          render: Resp?.msg,
          isLoading: false,
          autoClose: 1000,
        });
        // toast.error(Resp?.msg, 1000);
        SetError(Resp?.error);
      }
    }
    else {
      toast.update(toastid, {
        type: "error",
        render: "Fix all Validations",
        isLoading: false,
        autoClose: 1000,
      });
      // toast.error("Fix all Validations", 1000);
      SetError(errorcheck);
    }
    SetDisabledstatus({ Submit: false });
  };

  console.log("slfjsjfksjf", SelectedShop, formValue, Datas);




  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title">{location?.pathname == "/addadmin" ? "Add" : "Edit"} Admin</p>
            </div>
          </div>
        </div>
        {/* profile details */}
        <div className=" mt-4">
          <div className="mdvsec_border sec_border">
            <div className="row mdv_driverdtls_whole">
              <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12">
                <div className="mdv_driverdtls">
                  <img
                    className="tab_dummyimg me-3"
                    src={
                      (typeof formValue?.Profile == 'string' && formValue?.Profile)
                        ? `${config.IMG_URL}/admin/Profile/${formValue?.Profile}`
                        : (typeof formValue?.Profile !=
                          "string" && formValue?.Profile?.name)
                          ? URL.createObjectURL(formValue?.Profile)
                          : require("../../assests/images/dummyimg.png")
                    }
                    alt="tab_dummyimg"
                  />
                  {/* <div>
                                  <p className="mdv_drivername">
                                    {Datas?.[activeTab]?.FirstName
                                      ? Datas?.[activeTab]?.FirstName
                                      : Datas?.[activeTab]?.BrandName}
                                  </p>
                                </div> */}
                </div>
              </div>

            </div>
            <div className="mdv_drivertab jus_start">
              <p
                className={
                  activeTab == "profile"
                    ? "mdv_tabtext active"
                    : "mdv_tabtext"
                }
                onClick={() => setActiveTab("profile")}
              >
                Profile
              </p>
            </div>
          </div>

          {/* profile details */}
          {activeTab == "profile" && (
            <>
              <div className="mdv_profiledtls">
                <div className="mdv_border_div">
                  <p className="mdv_profilettl">
                    Personal Information
                  </p>
                </div>
                {console.log("dsfdsasfa", formValue)}
                <Row className="mdv_inputrow">
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">User Name</p>
                    <input
                      className="mdv_cmninput"
                      type="text"
                      id="username"
                      placeholder="Enter User Name"
                      value={formValue?.username}
                      onChange={(e) => OnChange(e)}
                    />
                    {Error?.username && (
                      <span className="error-msg">
                        {Error?.username}
                      </span>
                    )}
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Email Address</p>
                    <input
                      className="mdv_cmninput"
                      type="email"
                      id="EmailId"
                      placeholder="Enter Email"
                      value={formValue?.EmailId}
                      onChange={(e) => OnChange(e)}
                    />
                    {Error?.EmailId && (
                      <span className="error-msg">
                        {Error?.EmailId}
                      </span>
                    )}
                  </Col>

                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">Phone Number</p>
                    <PhoneInput
                      className="new_rephoneinp"
                      placeholder="Enter phone number"
                      id="Mobile"
                      onChange={(e) => OnChange(e, "Mobile")}
                      value={formValue?.Mobile}
                      defaultCountry="US"
                      country="US"
                      countries={["US", "IN"]}
                      international // Makes the input accept only international format
                      withCountryCallingCode // Includes country code in the input
                      displayInitialValueAsLocalNumber // Includes country code in the input
                    />
                    {Error?.Mobile && (
                      <span className="error-msg">
                        {Error?.Mobile}
                      </span>
                    )}
                  </Col>

                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">
                      {location?.pathname == "/addadmin"
                        ? "Enter Password"
                        : "Enter Password (Only if Want To Update)"}
                    </p>
                    <div className="reg_passwordinps">
                      <input
                        className="mdv_cmninput"
                        type={
                          passwordText == "password"
                            ? "password"
                            : "text"
                        }
                        id="Password"
                        placeholder="Enter Password"
                        onChange={(e) => OnChange(e)}
                      />
                      <i
                        onClick={() =>
                          setPasswordText(
                            passwordText == "text"
                              ? "password"
                              : "text"
                          )
                        }
                        className={
                          passwordText == "password"
                            ? "fa-solid fa-eye-slash"
                            : "fa-solid fa-eye"
                        }
                      ></i>
                    </div>
                    {Error?.Password && (
                      <span className="error-msg">
                        {Error?.Password}
                      </span>
                    )}
                  </Col>

                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <p className="mdv_inplabel">
                      Choose Profile
                    </p>
                    <input
                      className="mdv_cmninput"
                      type="file"
                      id="Profile"
                      placeholder=""
                      onChange={(e) => FileChange(e)}
                    />
                    {Error?.Profile && (
                      <span className="error-msg">
                        {Error?.Profile}
                      </span>
                    )}
                  </Col>
                </Row>
                {
                  <div className="mdv_update_dualbtn">
                    <button
                      className="blue_btn mdv_update"
                      type="button"
                      onClick={() => Submit()}
                    >
                      {location?.pathname == "/addadmin"
                        ? "Submit"
                        : "Update"}
                    </button>
                  </div>
                }
              </div>

              {/* <div className='mdv_update_dualbtn mt-3'>
              <button className='seconday_btn'>Cacnel</button>
            </div> */}
            </>
          )}
        </div>

        {/* end of profile details */}

      </section>
    </>
  );
}

export default AdminView;
